import React from 'react';
import { FormattedMessage } from 'react-intl';
import BaseModal from '../../../_shared/components/BaseModal';
import ScaleLoader from '../../../_shared/components/ScaleLoader';
import {
  Container,
  StyledCancel,
  StyledHeading,
  StyledSubHeading
} from './Styles';

const Loading = ({ closeModal }) => {
  const closeHandler = () => {
    if (closeModal) {
      closeModal();
    } else {
      window.close();
    }
  };

  return (
    <BaseModal
      isOpen
      width={490}
      isClickOverlayClose
      isClickEscClose
      bodyOpenClassName="ReactModal__LoadingRetailCreate"
      isFullScreen={false}
      onRequestClose={closeHandler}
    >
      <Container data-testid="retailLoading-container">
        <ScaleLoader />
        <StyledHeading testId="retailLoading-heading">
          <FormattedMessage id="retail.create.loading.heading" />
        </StyledHeading>
        <StyledSubHeading testId="retailLoading-Subheading">
          <FormattedMessage id="retail.create.loading.sub.heading" />
        </StyledSubHeading>
        <StyledCancel
          id="retailLoading-cancel-id"
          type="button"
          testId="retailLoading-cancel"
          onClick={closeHandler}
        >
          <FormattedMessage id="retail.create.loading.cancel" />
        </StyledCancel>
      </Container>
    </BaseModal>
  );
};

export default Loading;
